import { Switch } from '@mui/material'

interface PricingToggleProps {
  isYearly: boolean
  onToggle: (isYearly: boolean) => void
}

export default function PricingToggle({ isYearly, onToggle }: PricingToggleProps) {
  return (
    <Switch
      checked={isYearly}
      onChange={() => onToggle(!isYearly)}
      sx={{
        height: '42px',
        width: '66px',
        padding: '10px',
        '& .MuiSwitch-switchBase': {
          top: '14px',
          left: '13px',
          padding: '0',
          '& .MuiSwitch-input': {
            width: '570%',
            left: '-187%',
          },
          '&.Mui-checked': {
            transform: 'translateX(25px)',
            '+ .MuiSwitch-track': {
              opacity: 1,
              backgroundColor: '#E4E4E6',
            },
            '& .MuiSwitch-thumb': {
              background: '#252428',
            },
          },
          '& .MuiSwitch-thumb': {
            height: '14px',
            width: '14px',
            background: '#4E4F52',
            boxShadow: 'none',
            '&:before': {
              borderRadius: '100%',
              width: '10px',
              height: '10px',
              content: "' '",
              backgroundImage: 'linear-gradient(0deg, #101010 -76.62%, rgb(255 255 255) 131.05%)',
              padding: '5px',
              top: '-3px',
              left: '-3px',
              position: 'absolute',
              zIndex: -1,
            },
          },
        },
        '& .MuiSwitch-track': {
          backgroundColor: '#1B1F22',
          opacity: 1,
          borderRadius: '15px',
        },
      }}
      defaultChecked={isYearly}
    ></Switch>
  )
}
